// Een schrijfactie die nul rijen raakte is niet gelukt — ook al gaf hij geen
// fout.
//
// PostgREST meldt een door RLS geblokkeerde UPDATE niet als error. De policy
// laat de rij simpelweg niet zien, de UPDATE raakt nul rijen, en
// `{ error: null }` komt terug. Wie alleen op `error` kijkt, toont een groene
// toast voor iets dat niet gebeurd is. Dat is de duurste soort stilte: de
// gebruiker denkt dat het klaar is.
//
// De remedie is `.select()` achter de mutatie plakken — dan geeft PostgREST de
// geraakte rijen terug — en die tellen. Nul rijen is een fout.
//
// Dit is de CRM-brede kopie van `assertRowsWritten` uit
// `src/features/laadplein-designer/hooks/useScenarioEnergyLink.ts` (T5.3).
// Bewust een kopie en geen import: die hook woont in de Builder-feature, en
// het CRM hoort daar niet aan te hangen voor iets dat niets met tekenen te
// maken heeft.

export function assertRowsWritten<T>(
  data: T[] | null | undefined,
  onderwerp: string,
): asserts data is T[] {
  if (!data || data.length === 0) {
    throw new Error(
      `${onderwerp}: niets bijgewerkt — bestaat de rij nog, en heb je hier schrijfrechten?`,
    );
  }
}
